<div class="document-container">
  <div class="close-btn"><button class="nrk-button" (click)="onClose()">X</button></div>

  <!-- <div *ngIf="compilation && data.visibleMap.showInvoiceUpload"> -->
  <div class="side-buttons-left">
    <ng-container *ngFor="let section of ['transactionReceipt', 'proveOfDelivery', 'testCertificate']">
      <button *ngIf="data.visibleMap[section] && compilation[section]?.files?.length" class="btn btn-info btn-md" (click)="onDownload(section)">
        {{ config.get(section).label }}
      </button>
    </ng-container>

    <!-- <div *ngIf="getMessages()?.length > 0" class="mb-4 pt-4">
      <div><b>Messages</b></div>
      <ng-container *ngTemplateOutlet="messagingOverview; context: { fromWindow: false }"></ng-container>
    </div> -->
    <ngx-messaging [compilation]="compilation" [messagingMode]="messagingWindowMode.overview"></ngx-messaging>

  </div>

  <div class="side-buttons-right">
    <div>
      <ng-container *ngIf="page === 1">
        <button *ngIf="compilation.type != 5 || (!compilation.draft && compilation.invoiceDownloaded === false)" class="btn btn-info btn-md" (click)="onDownloadPdf()">Download PDF</button>
        <button *ngIf="compilation.type == 5 && compilation.invoiceDownloaded !== false"class="btn btn-info btn-md" (click)="onDownloadPdf(false, true)">PDF Copy</button>
        <button *ngIf="!warehousingPopup" class="btn btn-info btn-md" (click)="onDownloadPdf(true, false, true)">ZIP (document & attachments)</button>
        <button *ngIf="!warehousingPopup" class="btn btn-info btn-md" (click)="onDownloadPdf(true, false, true, true)">ZIP (attachments only)</button>
        <button *ngIf="!warehousingPopup" class="btn btn-info btn-md" (click)="onDownloadPdf(); onDownloadPdf(true, false, true, true)">PDF & ZIP</button>
        <button *ngIf="!warehousingPopup" class="btn btn-default btn-md" (click)="onClose()">Close</button>
          <!-- <button class="btn btn-md btn-info" (click)="logWindow.show()">Log</button> -->
      </ng-container>
      <ng-container *ngIf="page === 2">
        <!-- <div>{{compilation.testCertificate?.files.length}}</div>
        <div>{{compilation.testCertificates?.length}}</div> -->

        <div style="width:15rem;margin-bottom:1rem;">
          <ngx-dn-status [compilation]="compilation"></ngx-dn-status>
        </div>

        <div *ngIf="compilation.packingStatus === status.readyForPacking || compilation.confirmedByWarehousing" style="width:15rem;margin-bottom:1rem;">
          <button *ngIf="!compilation.confirmedByWarehousing" class="btn btn-danger btn-md" (click)="this.compilation.confirmedByWarehousing = true; saveField('confirmedByWarehousing')">Confirm by Warehousing</button>
          <button *ngIf="compilation.confirmedByWarehousing" class="btn btn-success btn-md">Confirmed by Warehousing</button>
        </div>

        <div class="mb-4 ml-2" *ngIf="treeLoaded">
          <!-- <ngx-form-js-date title="ETA Customer Date" [(value)]="compilation.etaCustomerDate"></ngx-form-js-date> -->
          <label>ETA Customer Date</label>
          <p class="mb-4"><b>{{(tree.linkedOC?.etaCustomerDate || compilation.etaCustomerDate) | date : 'yy-MM-dd'}}</b></p>
          <p class="mb-4 p-2" *ngIf="etaDispatchError(compilation)" style="background-color:tomato">Dispatch date > ETA date<br>contact Administration</p>
          <label>Dispatch Date</label>
          <ngx-doc-form-date [value]="tree.linkedOC?.vieDispatchDate || compilation.vieDispatchDate" (valueChange)="dispatchDateChanged($any($event))"></ngx-doc-form-date>
          <!-- <label class="mt-2">ETA Customer Date</label>
          <ngx-doc-form-date [value]="compilation.etaCustomerDate" (valueChange)="etaDateChanged($any($event))"></ngx-doc-form-date> -->
        </div>
        <ngx-pallet-label [compilation]="compilation" [grossWeight]="0" [warehousingPopup]="true"></ngx-pallet-label>
        <div *ngIf="warehousingPopup"> <button class="btn btn-info btn-md" [attr.disabled]="(!compilation.testCertificates?.length && !linkedSpoTestCertificates?.length) || null" (click)="printTestCertificates()">Print Test Certificate</button></div>
        <div *ngIf="warehousingPopup"> <button class="btn btn-info btn-md" (click)="data.setDocConfigMaps(docType.get('DN').id); docToPrint=compilation;page = 1">Delivery Note</button></div>
        <div *ngIf="warehousingPopup"> <button class="btn btn-info btn-md" (click)="data.setDocConfigMaps(docType.get('IN').id); docToPrint=invoice;page = 1" [attr.disabled]="!invoice || null">Invoice</button></div>
        <div *ngIf="warehousingPopup"> <button class="btn btn-info btn-md" (click)="data.setDocConfigMaps(docType.get('PFIN').id); docToPrint=pfInvoice;page = 1" [attr.disabled]="!pfInvoice || null">Proforma Invoice</button></div>
        <ngx-messaging #messageWindow [compilation]="compilation" [messagingMode]="messagingWindowMode.messageWindow"></ngx-messaging>
        <div *ngIf="warehousingPopup"> <button class="btn btn-md btn-info" (click)="messageWindow.show()">Messaging</button></div>
        <!-- <button *ngIf="warehousingPopup" 
            class="btn btn-md btn-info" 
            (click)="messageWindow.show()" 
            [disabled]="messageWindow.isOpen"
        >
            Messaging
        </button> -->
      </ng-container>
      <div *ngIf="warehousingPopup"> <button class="btn btn-info btn-md" (click)="packingComponent.disabled = false">Edit Packing</button></div>
      <div *ngIf="warehousingPopup"> <button class="btn btn-info btn-md" (click)="reloadData.emit();reportsPrinter.reloadData()">Reload Data</button></div>
      <div *ngIf="warehousingPopup &&  page === 1"> <button class="btn btn-default btn-md" (click)="page = 2">Back</button></div>
      <div *ngIf="warehousingPopup &&  page === 2"> <button class="btn btn-default btn-md" (click)="onClose()">Close</button></div>
    </div>
  </div>

  <div *ngIf="page === 1" class="document">
    <ngx-document-printer
      #documentPrinter
      [buttons]="false"
      [compilation]="docToPrint" 
      [userOptions]="$any(data.userOptions)"
      [deliveryConditions]="getSelected($any(compilation).deliveryConditions, $any(deliveryConditionOptions))"
      [taxHint]="getSelected(compilation.taxHint, $any(taxHintOptions))"
      [relatedDocuments]="$any(relatedDocuments)"
      [latestVersionItems]="data.latestVersionItems"
      (done)="onShowDocumentPreview(false)">
    </ngx-document-printer>
    <!-- [issuedBy]="getSelected($any(compilation).issuedBy, data.userOptions)" -->
  </div>

  <div *ngIf="page === 2" class="document pt-2">
    <h2>
      {{compilation | documentNumber}}
      <!-- <span class="ml-4 packing-status" [ngStyle]="{'background-color': ['#ddd','#fb3c','#0afa','#0c0a'][compilation.packingStatus || 0]}">
        {{['Not Ready for Packing','Ready for Packing','Ready for Dispatch','Dispatched'][compilation.packingStatus || 0]}}
      </span> -->
    </h2>
    <!-- <div class="packing-status">
      <ngx-dn-status [compilation]="compilation"></ngx-dn-status>
    </div> -->
    <ngx-reports-printer #reportsPrinter [compilation]="compilation" [search]="warehousingData.search" [pdfSidebar]="true" [warehousingPopup]='true' [warehousingData]="warehousingData"></ngx-reports-printer>
    <div class="section">

      <ngx-document-sub-components #packingComponent [compilation]="compilation" [print]="true" single="packingConditions"></ngx-document-sub-components>

      <div class="mb-4 text-center">
        Tracking Code:
        <ngx-doc-form-texfield [(value)]="compilation.trackingCode" (valueChange)="saveField('trackingCode')"></ngx-doc-form-texfield>
      </div>
      <table class="nrk-table" style="margin:0 auto">
        <tr><th>Pos</th><th>Pallet ID</th><th>Gross Weight</th><th>Tracking Code</th><th></th></tr>
        <ng-container *ngFor="let pallet of compilation.packingConditions; index as pos">
          <tr>
            <td>{{pos+1}}</td>
            <td>{{pallet.palId}}</td>
            <td><ngx-doc-form-texfield [(value)]="pallet.weightOverride" mode="integer" (valueChange)="this.event.emitRecalcPacking(this.compilation);savePacking()"></ngx-doc-form-texfield></td>
            <!-- <td><ngx-doc-form-texfield [(value)]="pallet.trackingCode" (valueChange)="savePacking()"></ngx-doc-form-texfield></td> -->
            <td [style]="inputTableSaved">Changes Saved ✓</td>
          </tr>
        </ng-container>
      </table>
      <div class="section" style="padding:4rem;text-align:center">
        <button
          *ngIf="compilation.packingStatus <= status.readyForPacking"
          class="btn btn-md btn-info mr-3" 
          (click)="setPackingStatus(status.readyForDispatch)" 
          [attr.disabled]="!compilation.packingImages?.length || compilation.packingStatus !== status.readyForPacking || null">Set Ready for Dispatch
        </button>
        <button 
          *ngIf="compilation.packingStatus >= status.readyForDispatch && compilation.packingStatus <= status.dispatched"
          class="btn btn-md btn-info mr-3" 
          (click)="setPackingStatus(status.dispatched)" 
          [attr.disabled]="!compilation.packingImages?.length || compilation.packingStatus !== status.readyForDispatch || null">Set Dispatched
        </button>
        <!-- <button 
          *ngIf="compilation.packingStatus >= status.dispatched"
          class="btn btn-md btn-info mr-3" 
          (click)="setPackingStatus(status.delivered);onClose()" 
          [attr.disabled]="!compilation.proveOfDelivery?.files?.length || compilation.packingStatus !== status.dispatched || null">Set Delivered, Save and Close
        </button> -->
        <button 
          *ngIf="compilation.packingStatus === status.dispatched"
          class="btn btn-md btn-info mr-3" 
          (click)="setPackingStatus(status.delivered)"
          [attr.disabled]="!compilation.proveOfDelivery?.files?.length || null"
          >Set Delivered
        </button>
        <button 
          *ngIf="compilation.packingStatus >= status.delivered"
          class="btn btn-md btn-info mr-3" 
          (click)="setPackingStatus(status.completed);onClose()" 
          [attr.disabled]="!compilation.proveOfDelivery?.files?.length || compilation.packingStatus !== status.delivered || null">
          Set Completed, Save and Close
        </button>
        <button
          *ngIf="compilation.packingStatus <= status.readyForDispatch"
          class="btn btn-md btn-primary" 
          (click)="setPackingStatus(status.readyForPacking)" 
          [attr.disabled]="compilation.packingStatus !== status.readyForDispatch || null">Undo Ready for Dispatch
        </button>
        <button 
          *ngIf="compilation.packingStatus === status.dispatched"
          class="btn btn-md btn-primary" 
          (click)="setPackingStatus(status.readyForDispatch)" 
          [attr.disabled]="compilation.packingStatus !== status.dispatched || null">Undo Set Dispatched
        </button>
        <button 
          *ngIf="compilation.packingStatus === status.delivered"
          class="btn btn-md btn-primary" 
          (click)="setPackingStatus(status.dispatched)" 
          [attr.disabled]="compilation.packingStatus !== status.delivered || null">Undo Set Delivered
        </button>
      </div>

      <div class="mb-4">
        <ngx-form-upload 
          [(files)]="compilation.packingImages"
          url="/api/v1/upload"
          title="Packing Images Upload"
          accept="image/jpeg"
          (filesChange)="onFileUpload($event, 'packingImages', 'Image upload', 'Warehousing image upload')"
          [preview]="true"
        ></ngx-form-upload>
      </div>

      <div class="mb-4">
        <ngx-form-upload 
          [(files)]="compilation.proveOfDelivery.files"
          url="/api/v1/upload"
          title="Proof of Delivery Upload"
          accept="application/pdf"
          (filesChange)="onProveOfDeliveryUpload(compilation.proveOfDelivery)"
        ></ngx-form-upload>
      </div>

      <div class="mb-4">
        <ngx-form-upload 
          [(files)]="compilation.freightForwarder"
          url="/api/v1/upload"
          title="Freight Forwarder Shipping Label"
          accept="application/pdf,image/jpeg"
          (filesChange)="onFileUpload($event, 'freightForwarder', 'Freight forwarder shipping label upload')"
        ></ngx-form-upload>
      </div>

      <div class="mb-4">
        <ngx-form-upload 
          [(files)]="compilation.scannedPacking"
          url="/api/v1/upload"
          title="Scanned Packing instructions"
          accept="application/pdf,image/jpeg"
          (filesChange)="onFileUpload($event, 'scannedPacking', 'Scanned packing instructions upload')"
        ></ngx-form-upload>
      </div>

    </div>

    <div class="log d-flex align-items-center justify-content-center mb-4">

      <div>
        <div *ngIf="getLogEntriesFor(this.compilation)?.length > 0">
          <div><b>Log</b></div>
          <table class="nrk-table">
            <thead>
              <tr><th>User</th><th>Date</th><th>Entry</th><th>Details</th></tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let entry of getLogEntriesFor(this.compilation)">
                <tr>
                  <td>{{data.userShort(entry.user)}}</td>
                  <td>{{entry.timestamp | date : 'yyyy-MM-dd hh:mm'}}</td>
                  <td>{{entry.subject}}</td>
                  <td style="max-width:33rem">{{entry.message}}</td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>

    </div>

  </div>

</div>




<!-- <nrk-window #messageWindow [style]="{ 'width':'50rem', 'height': '35rem' }">

  <nrk-header>Messaging</nrk-header>
  
  <nrk-content>

      <ng-container *ngIf="messagingPage === messagingWindowPage.writeMessage || messagingPage === messagingWindowPage.messageDetails">
        Recipient:
        <ngx-doc-form-dropdown [(value)]="currentMessage.recipient" [options]="data.userOptions"></ngx-doc-form-dropdown>
        <br>
        Subject (max 60 chars):
          <ngx-form-text 
              [(value)]="currentMessage.subject"
              [maxChars]="60"
              [disabled]="messagingPage === messagingWindowPage.messageDetails || null"
          ></ngx-form-text>
          Message (max 200 chars):
          <ngx-form-text
              [(value)]="currentMessage.message"
              [multiline]="10" [maxChars]="200"
              [disabled]="messagingPage === messagingWindowPage.messageDetails || null"
          ></ngx-form-text>
      </ng-container>

      <ng-container *ngIf="messagingPage === messagingWindowPage.overview">
        <ng-container *ngTemplateOutlet="messagingOverview; context: { fromWindow: true }"></ng-container>
      </ng-container>

  </nrk-content>

  <nrk-footer>

      <ng-container *ngIf="messagingPage === messagingWindowPage.writeMessage">
          <button
              class="btn btn-md btn-info" 
              (click)="commitMessage();"
              [attr.diabled]="!currentMessage.subject?.length || !currentMessage.message?.length || null"
          >Send</button>
          <button
              class="btn btn-md btn-info"
              (click)="this.currentMessage.subject='';this.currentMessage.message=''"
          >Clear</button>
      </ng-container>

      <ng-container *ngIf="messagingPage === messagingWindowPage.messageDetails">
          <button class="btn btn-md btn-default" (click)="messagingPage = messagingWindowPage.overview">Back</button>
          <button class="btn btn-md btn-danger" (click)="deleteMessage(currentMessage)">Delete</button>
          <button class="btn btn-md btn-info" (click)="replyMessage(currentMessage);">Reply</button>
      </ng-container>

      <ng-container *ngIf="messagingPage === messagingWindowPage.overview">
          <button class="btn btn-md btn-info"
              (click)="newMessage()"
          >New Message</button>
      </ng-container>


      <button
          class="btn btn-md btn-default"
          (click)="messageWindow.hide()"
      >Close</button>

  </nrk-footer>

</nrk-window>  -->





<!-- <ng-template #messagingOverview let-fromWindow="fromWindow">
  <table class="nrk-table w-100 nrk-row-select">
    <thead>
        <tr>
            <th>User</th><th>Subject</th><th>Date</th>
        </tr>
    </thead>
    <tbody>
        <ng-container *ngFor="let message of getMessages()">
            <tr (click)="setCurrentMessage(message, fromWindow)">
                <td>{{getUser(message)}}</td>
                <td>{{message.subject}}</td>
                <td>{{message.timestamp | date : 'yyyy-MM-dd hh:mm'}}</td>
            </tr>
        </ng-container>
    </tbody>
  </table>  
</ng-template> -->




<nrk-window #printUpdatedDnTpl [style]="{ 'width':'15rem', 'height': '10rem' }" class="print-updated-dn">
  <nrk-header>New Dispatch Date</nrk-header>
  <nrk-content>Print Updated Delivery Note</nrk-content>
  <nrk-footer>
    <button class="btn btn-md btn-info" (click)="docToPrint=compilation;page=1;printUpdatedDnTpl.hide()">Print</button>
    <button class="btn btn-md btn-default" (click)="printUpdatedDnTpl.hide()">Close</button>
  </nrk-footer>
</nrk-window>

